export default "__VITE_ASSET__CFUh7Crg__"